// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bundle-discount-section[data-v-7cdfb43e]{margin:8px 0 16px}", ""]);
// Exports
module.exports = exports;
